import { DATA_TOOL_LIMITS, normalizeText, serializeCsv, validateTextSource } from "./data-tool-core.js";
import { parseJsonAst, serializeJsonAst } from "./json-formatter-core.js";

export function jsonToCsv(source, { delimiter = "," } = {}) {
  const text = normalizeText(source);
  const validation = validateTextSource(text, "JSON");
  if (validation) return { error: validation, output: "" };
  try {
    const root = parseJsonAst(text);
    const records = root.type === "array" ? root.items : [root];
    if (!records.length) return { error: "The JSON array is empty.", output: "" };
    if (records.length > DATA_TOOL_LIMITS.rows)
      return { error: `JSON exceeds the ${DATA_TOOL_LIMITS.rows.toLocaleString("en-US")} record limit.`, output: "" };
    if (records.some(record => record.type !== "object"))
      return { error: "JSON must be an object or an array of objects.", output: "" };

    const headers = [];
    const seen = new Set();
    const maps = records.map(record => {
      const map = new Map();
      for (const entry of record.entries) {
        if (map.has(entry.key.value)) throw new Error(`Duplicate property "${entry.key.value}" cannot be represented safely in CSV.`);
        map.set(entry.key.value, entry.value);
        if (!seen.has(entry.key.value)) {
          seen.add(entry.key.value);
          headers.push(entry.key.value);
        }
      }
      return map;
    });
    if (!headers.length) return { error: "JSON objects need at least one property.", output: "" };
    if (headers.length > DATA_TOOL_LIMITS.columns)
      return { error: `JSON exceeds the ${DATA_TOOL_LIMITS.columns} column limit.`, output: "" };
    const rows = [
      headers,
      ...maps.map(map => headers.map(header => cellValue(map.get(header))))
    ];
    const output = serializeCsv(rows, { delimiter });
    return { error: "", output, records: records.length, columns: headers.length };
  } catch (error) {
    return { error: friendlyJsonError(error), output: "" };
  }
}

function cellValue(node) {
  if (!node || node.type === "primitive" && node.raw === "null") return "";
  if (node.type === "string") return node.value;
  if (node.type === "primitive") return node.raw;
  return serializeJsonAst(node, { compact: true });
}

function friendlyJsonError(error) {
  if (String(error?.message || "").startsWith("Duplicate property")) return error.message;
  if (error?.code === "NESTING_LIMIT") return "JSON nesting is too deep.";
  return "Invalid JSON. Check quotes, commas, brackets, and property names.";
}
